export enum SecurityOptionsBit {
  Overwrite = 0,
  Append = 1,
  AllDocs = 2,
  SubFolders = 4,
  SubDocs = 8,
  Remove = 16,
  Everyone = 32,
  SkipSecurityValidation = 64,
  AllFolders = 128,
  PurgeTopicAcl = 256,
  UseTemporaryAcl = 512,
  ModifySystemAcl = 1024,
  All = 2048,
  ApplyOptionsSubFoldersSameSecurity = 8192,
  ApplyOptionsSubFoldersCustomSecurity = 16384,
  ApplyOptionsPurgeDocumentCustomAcl = 32768,
}
